// extracted by mini-css-extract-plugin
export default {"contactus_page_container":"styles_contactus_page_container__NNhv1","icon_container":"styles_icon_container__rk0F1","icon_wrapper":"styles_icon_wrapper__I9PW1"};